"use client";

import { useEffect, useState } from "react";
import clsx from "clsx";

interface StaggeredTextProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  index?: number;
}

export default function StaggeredText({
  children,
  className,
  delay = 0,
  index = 0,
}: StaggeredTextProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay + index * 150);

    return () => clearTimeout(timer);
  }, [delay, index]);

  return (
    <div
      className={clsx(
        "transition-all duration-700 ease-out",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4",
        className
      )}
    >
      {children}
    </div>
  );
}
